import { Component } from '@angular/core';

@Component({
  selector: 'app-user-switcher',
  templateUrl: './user-switcher.component.html',
  styleUrls: ['./user-switcher.component.scss']
})
export class UserSwitcherComponent {

}
